export default __webpack_public_path__ + "static/media/Mocha.afea9c73.jpg";